import { getLanguageFromStorage } from 'syf-js-utilities'

const setCookiesForMarketPlaceRedirect = (client: string): void => {
  const cookieAttributes: string = `path=/;secure;samesite=strict;max-age=120`
  const cookieValue = { vct: client, vlg: getLanguageFromStorage() }
  document.cookie = `vsc=${encodeURIComponent(
    JSON.stringify(cookieValue)
  )};${cookieAttributes}`
}

export default setCookiesForMarketPlaceRedirect
